export default {
  brandColor1: '#242424',
  complimentaryColor1: '#fff',
  brandColor2: '#242424',
  complimentaryColor2: '#fff',
};
